import React, { useState } from 'react';
import myImage from "../images/ustlogo1.png";
import myProfile from "../images/profile.jpg";
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const navigate = useNavigate();

  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible); // Toggle the dropdown visibility
  };

  const handleLogout = () => {
    //localStorage.clear();
    //sessionStorage.clear();
    navigate('../Login');
    setIsDropdownVisible(false);
  };

  const handleChangePassword = () => {
    //localStorage.clear();
    navigate('../change-password');
    setIsDropdownVisible(false);
  };

  return (
    <header className="bg-[#1f415b] text-white fixed w-full top-0 left-0 z-50">
      <div className="flex justify-between items-center p-4 bg-primary text-white h-[70px]">
        <div className="flex items-center">
          <img
            src={myImage}
            className="h-[40px] md:h-[70px] mr-7"
            alt="Logo"
          />
          <div className="text-sm md:text-lg">EMPLOYEE PROCESS MANAGEMENT</div>
        </div>
        <div className="relative">
          <button
            className="w-[50px] h-[50px] rounded-full border-2 border-gray-300 overflow-hidden"
            onClick={toggleDropdown}
          >
            <img
              src={myProfile}
              alt="Profile"
              className="w-full h-full object-cover"
            />
          </button>
          {isDropdownVisible && (
            <div className="absolute right-0 top-[60px] bg-white border border-gray-300 shadow-md rounded-md p-4 w-[180px]">
              <button
                className="text-sm text-black hover:text-blue-700 mt-2 w-full text-left"
                onClick={handleChangePassword}
              >
                Change Password
              </button>
              <button
                className="text-sm text-black hover:text-blue-700 mt-2 w-full text-left"
                onClick={handleLogout}
              >
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};
export default Header;